import { ref, onMounted } from 'vue'
// by convention, composable function names start with 'use'
export function useMultipleOverlays(number) {
	// state encapsulated and managed by the composable
	const overlay_control_vars = ref([])

	function flipOverlay(index) {
		overlay_control_vars.value[index] = !overlay_control_vars.value[index]
	}

	onMounted(() => {
		for (var i = 0; i < number; i++) {
			overlay_control_vars.value[i] = false
		}
	})
	// expose managed state as return value
	return {
		overlay_control_vars,
		flipOverlay,
	}
}
